$(function () {
        group_array = {};// グローバル変数

        var id_name = 'group'; // 変化対象id名
        var group_count = 7; // 必要個数
        // クラス名とid名は数値も含めて同じ関係になる
        var active_item = '#sub_nav li';
        $(window).on('load', function () {
            for (var i = 1; i <= group_count; i++) {//対処の数だけループ
                var name = id_name + i;
                if ($('#' + name).length) {// 存在しているか確認
                    group_array[name] = $('#' + name).offset().top + $('#' + name).outerHeight();
                }
            }
            group_array['finish'] = $('.finish').offset().top + $('.finish').outerHeight();
        });

        $(window).scroll(function () {
            var page = $(window).scrollTop() + $(window).height();
            var check = judge(page, group_array);
            function judge(page, target_array = {}) {
                var group = false;
                $.each(target_array, function (key, thisOffset) {
                    if (page > (thisOffset - 600)) {
                        group = key;
                    }
                })
                return group;
            }
            $(active_item).removeClass('active');
            if (check && check != 'finish') {
                var target = $(active_item + '.' + check);
                target.addClass('active');
            }
        });

    });